import { Component, ElementRef, Input } from '@angular/core';
import { BlockableUI } from 'primeng/api';

@Component({
    selector: 'app-blockable,[blockable]',
    template: `
        <div [ngStyle]="style" [ngClass]="class" class="tw-flex tw-flex-100 tw-items-stretch tw-place-content-stretch tw-h-full">
            <ng-content></ng-content>
        </div>
    `
})
export class BlockableComponent implements BlockableUI {
    @Input() style: any;
    @Input() class: any;

    constructor(private el: ElementRef) {
    }

    getBlockableElement(): HTMLElement {
        return this.el.nativeElement.children[0];
    }
}
